import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ModusButtonModule } from '@trimble-gcs/modus';

export enum TreeIcon {
  On,
  Off,
  Error,
  Loading,
  Unavailable,
}

@Component({
  selector: 'sd-scandata-tree-icon',
  imports: [CommonModule, ModusButtonModule, MatProgressSpinnerModule],
  templateUrl: './scandata-tree-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScandataTreeIconComponent {
  readonly treeIcon = input.required<TreeIcon>();
  readonly disabled = input.required<boolean>();
  readonly clicked = output<void>();
  readonly treeIconType = TreeIcon;

  onTreeIconClick() {
    if (this.disabled()) return;

    this.clicked.emit();
  }
}
